import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const WorkspaceContext = createContext();

export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};

export const WorkspaceProvider = ({ children }) => {
  const { user } = useAuth();
  const [currentWorkspace, setCurrentWorkspace] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      fetchWorkspaces();
    }
  }, [user]);

  const fetchWorkspaces = async () => {
    try {
      setLoading(true);
      // Mock workspaces data
      const mockWorkspaces = [
        {
          id: '1',
          name: 'Personal Workspace',
          description: 'Your personal QR code workspace',
          role: user?.role === 'admin' ? 'owner' : 'member',
          qrCount: 12,
          memberCount: 1
        },
        {
          id: '2',
          name: 'Team Workspace',
          description: 'Collaborate with your team',
          role: 'member',
          qrCount: 24,
          memberCount: 5
        }
      ];
      
      setWorkspaces(mockWorkspaces);
      if (mockWorkspaces.length > 0 && !currentWorkspace) {
        setCurrentWorkspace(mockWorkspaces[0]);
      }
    } catch (error) {
      console.error('Failed to fetch workspaces:', error);
    } finally {
      setLoading(false);
    }
  };

  const createWorkspace = async (name) => {
    try {
      // Mock workspace creation
      const newWorkspace = {
        id: Date.now().toString(),
        name,
        description: '',
        role: 'owner',
        qrCount: 0,
        memberCount: 1
      };
      
      setWorkspaces(prev => [...prev, newWorkspace]);
      setCurrentWorkspace(newWorkspace);
      return newWorkspace;
    } catch (error) {
      throw error;
    }
  };

  const switchWorkspace = (workspace) => {
    setCurrentWorkspace(workspace);
  };

  const value = {
    currentWorkspace,
    workspaces,
    loading,
    createWorkspace,
    switchWorkspace,
    fetchWorkspaces
  };

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
};